import service from 'Services'
import { create } from 'zustand'

// Define the state type
interface State {
  notifications: Notification[]
  loading: boolean
  fetchNotifications: () => Promise<void>
}
interface Notification {
  date: string
  read: boolean
  type: string
  icon: string
  link: string
  id: string
  title: string
  content: string
}

const useNotificationsStore = create<State>((set) => ({
  notifications: [],
  loading: false,
  fetchNotifications: async () => {
    try {
      set(() => ({ loading: true }))
      const notifications = await service.getNotifications()
      if (!notifications || notifications.error) {
        throw new Error('Failed to fetch notifications')
      }
      set(() => ({ notifications: notifications }))
    } catch (error) {
      console.error('Error fetching notifications:', error)
    } finally {
      set(() => ({ loading: false }))
    }
  },
}))

export default useNotificationsStore
